export enum DocumentCategory {
  PERSONAL = 'personal',
  CLUBS = 'club',
  CURRENT_STATUSES = 'current-statuses',
  ARCHIVE = 'archive',
}

export enum DocumentFilterType {
  ALL = 'all',
  DOCUMENTS = 'documents',
  TABLES = 'tables',
  IMAGES = 'images',
}

export enum DocumentOrderByType {
  DATE = 'date',
  NAME = 'name',
}
